import api from './apiService';
import apiRoutes from './apiRoutes';

// Progressive (lazy) standards catalog. Each V2 endpoint returns { items: [...] };
// we return { result: <array> } so the tree component keeps reading `res.result`.

// Page load — fetch all main standards
export const getAllMainStandardsAdminAsync = async () => {
  try {
    const response = await api.get(apiRoutes.standards.getMainStandards);
    return { result: response.result.items || [] };
  } catch (error) {
    throw error;
  }
};

// On main-standard click — fetch its sub-standards
export const getSubStandardsByMainAsync = async (mainStandardId) => {
  try {
    const response = await api.get(apiRoutes.standards.getSubStandards(mainStandardId));
    return { result: response.result.items || [] };
  } catch (error) {
    throw error;
  }
};

// On sub-standard click — fetch its items
export const getItemsBySubStandardAsync = async (subStandardId) => {
  try {
    const response = await api.get(apiRoutes.standards.getItems(subStandardId));
    return { result: response.result.items || [] };
  } catch (error) {
    throw error;
  }
};
